import {useQuery} from 'react-query';
import {getFarmProducts} from 'services/products';

const useGetfarmProducts = () => {
  const {data, isLoading, refetch} = useQuery(['farm-farm'], getFarmProducts);
  return {
    farmProductsData: data,
    farmProductsIsloading: isLoading,
    refetch,
  };
};
export default useGetfarmProducts;
